namespace GeniuzPOS.Product {
    export interface CsUnitForm {
        UnitId: Serenity.StringEditor;
        UnitName: Serenity.StringEditor;
    }

    export class CsUnitForm extends Serenity.PrefixedContext {
        static formKey = 'Product.CsUnit';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CsUnitForm.init)  {
                CsUnitForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(CsUnitForm, [
                    'UnitId', w0,
                    'UnitName', w0
                ]);
            }
        }
    }
}
